import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ServiceGuard } from '../_guards/service.guard';
import { EnvSpecific } from '../environs/models/env-specific';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';

@Injectable()
export class GdprService {
  // set and retrive here
  userData: Array<any> = [];

  constructor(private readonly _http: Http, private readonly _serviceGuard: ServiceGuard) { }

  get(id: number, envSpecific: EnvSpecific, isOrionId = true, isGdpr = true) {
    const url = `${envSpecific.orionServiceUrl}/contacts/v2/gdpr/id?id=${id}&hashCode=${this._serviceGuard.getHashCode()}`;
    return this._http
      .get(url,
        { headers: this._serviceGuard.authJsonHeaders() })
      .map((response: Response) => response.json());
  }

  create(gdpr: any, envSpecific: EnvSpecific) {
    const url = envSpecific.orionServiceUrl + `/contacts/v2/optout?hashCode=${this._serviceGuard.getHashCode()}`;
    return this._http.put(url, JSON.stringify(gdpr),
      { headers: this._serviceGuard.authJsonHeaders() }).map((response: Response) => { });
  }

  getMailingAddress(id: number, envSpecific: EnvSpecific) {
    return this._http
      .get(envSpecific.orionServiceUrl + '/contacts/v2/address?contactId=' + id,
        { headers: this._serviceGuard.authJsonHeaders() })
      .map((response: Response) => response.json());
  }
}
